<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="TITLE">The Story Luke Tells</p>
<p class="SUBTITLE">Luke’s Unique Witness to the Gospel</p>
<p class="AUTHOR">Justo L. González</p>
<p class="COMPANY"><span class="sc">William B. Eerdmans Publishing Company<br/></span>Grand Rapids, Michigan / Cambridge, U.K.</p>
<p class="COPYRIGHT">© 2015 Justo L. González<br/>All rights reserved<br/><br/><span class="sc">Wm. B. Eerdmans Publishing Co.<br/></span>2140 Oak Industrial Drive <span class="sc">n.e.</span>, Grand Rapids, Michigan 49505 /<br/><span class="sc">p.o.</span> Box 163, Cambridge <span class="sc">cb3 9pu</span> U.K.<br/><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a><br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">González, Justo L.<br/>The story Luke tells: Luke’s unique witness to the gospel /<br/>Justo L. González.<br/>pages   cm<br/>ISBN 978-0-8028-7200-5 (pbk.: alk. paper)<br/>eISBN 978-1-4674-4297-8 (ePub)<br/>eISBN 978-1-4674-4257-2 (Kindle)<br/>1. Bible. Luke — Criticism, interpretation, etc.<br/>2. Bible. Acts — Criticism, interpretation, etc. I. Title.<br/><br/>BS2589.G66 2015<br/>226.4´06 — dc23<br/>                 2014033462</p>
<p class="NRSV">Unless otherwise noted, the Scripture quotations in this publication are from the New Revised Standard Version Bible, copyright © 1989 by the Division of Christian Education of the National Council of Churches of Christ in the U.S.A., and used by permission.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Gonzalez_The_Story_Luke_Tells_text_CC.vue?be6b1d40